import { Form, FormInstance, Input, Result } from 'antd'
import { useEffect } from 'react'
import { WarningOutlined } from '@ant-design/icons'
import LocalizationKeys from '../../../i18n/LocalizationKeys'
import { useAppSelector } from '../../../store/hooks'
import { selectSelectedTemplate } from '../../../store/TemplateReducer'
import i18n from '../../../i18n/setupLocalization'
import { requiredRule } from '../../../helpers/rules'
import { selectSelectedControl } from '../../../store/ControlReducer'

interface Props {
  form: FormInstance
}

const Delete = ({ form }: Props) => {
  const item = useAppSelector(selectSelectedControl())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) return <></>

  return (
    <Form form={form} layout="vertical">
      <Result
        title={i18n.t('Are you sure to delete?')}
        icon={<WarningOutlined style={{ color: '#dc4446' }} />}
      />
      <Form.Item name="id" required rules={[requiredRule()]} className="d-none">
        <Input type="hidden" />
      </Form.Item>
    </Form>
  )
}

export default Delete
